/*
================================================================ 
          Copyright (c) 2018-2020 Digitize Things Inc.           
                      All rights reserved.                       
================================================================ 
*/

import React from "react";
import CreatableSelect, { components } from "react-select";
import classes from "../checkout.module.css";
import { withTranslation, Trans } from "react-i18next";

const BanSelect = (props) => {
  const { customers, selected, onSelect, addBan, disabled } = props;
  return (
    <div>
      <CreatableSelect
        components={{ MenuList }}
        classNamePrefix="SearchInputClassPrefix"
        className={"SearchInputClassPrefix__myinputOuter"}
        isClearable={true}
        // isSearchable={selected ? false : true}
        options={customers}
        value={selected}
        isDisabled={disabled}
        placeholder={props.t("SELECT_CUSTOMER_BAN")}
        menuPosition={"fixed"}
        onChange={(e) => {
          onSelect(e ? e : {});
        }}
        addBan={addBan}
        id={"banSelect"}
        name={"banSelect"}
      />
    </div>
  );
};

const MenuList = (props) => {
  return (
    <div>
      {/* <div  className={classes.addBanDiv} onClick={() => { props.selectProps.addBan(true) }}>Add New BAN</div> */}
      <components.MenuList {...props}>{props.children}</components.MenuList>
    </div>
  );
};

export default withTranslation("translations")(BanSelect);
